import React from 'react';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent } from '@/components/ui/dialog';

interface PicksUpdatedModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAddToBetSlip?: () => void;
  onReturnToLobby: () => void;
  potentialWin?: string;
  betAmount?: string;
  frameUrl?: string;
  isUpdate?: boolean;
}

const PicksUpdatedModal: React.FC<PicksUpdatedModalProps> = ({
  isOpen,
  onClose,
  onAddToBetSlip,
  onReturnToLobby,
  _potentialWin = '813.95',
  _betAmount = '10',
  _frameUrl = '1597882308',
  isUpdate = false,
}) => {
  const { t } = useTranslation();

  const _handleAddToBetSlip = () => {
    onAddToBetSlip?.();
    onClose();
  };

  const handleReturnToLobby = () => {
    onReturnToLobby();
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        data-test-id="picks-updated-modal"
        className="bg-[#1a1a1a] border-0 w-[calc(100%-2rem)] max-w-md rounded-2xl p-0 overflow-hidden [&>button:last-child]:hidden"
      >
        {/* Close button */}
        <button
          data-test-id="close-modal-btn"
          onClick={onClose}
          className="absolute right-4 top-4 text-gray-400 hover:text-white transition-colors z-50"
          aria-label="Close"
        >
          <X className="h-6 w-6" />
        </button>

        {/* Content */}
        <div className="relative">
          <div className="pt-8 px-8 pb-8">
            {/* Title */}
            <h2 className="text-white text-3xl font-bold text-center mb-4">
              {t('modal.picksSubmitted.title')}
            </h2>

            {/* Subtitle */}
            <p className="text-gray-300 text-center text-lg mb-8">
              {t('modal.picksSubmitted.message')} <br />
              {t('modal.picksSubmitted.editMessage')}
            </p>

            {/* Action buttons */}
            <div className="space-y-3">
              <Button
                data-test-id="return-to-lobby-btn"
                onClick={handleReturnToLobby}
                variant="default"
                className="w-full bg-bet99-primary hover:bg-bet99-primary/90 text-white font-semibold py-6 text-lg rounded-xl"
              >
                {t('modal.picksSubmitted.returnToLobby')}
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PicksUpdatedModal;
